import { CRow } from '@coreui/react'
import React, { useState, useEffect } from "react";
import MultipleChoice from './MultipleChoice';
import MultipleSelect from './MultipleSelect';
import TrueFalse from './TrueFalse';
import YesNo from './YesNo';
import NumericResponse from './NumericResponse';
import FillInTheBlanks from './FillInTheBlanks';
import TextAnswer from './TextAnswer'
import "./QuizComponent.css";
import postApiCall from 'src/server/postApiCall';

function ReviewQuiz({ trainingId, blendedId,learningPlanId, assignmentId }) {
  const trainingIdProp = trainingId;
  const blendedIdProp = blendedId;
  const learningPlanIdProp = learningPlanId;
  const assignmentIdProp = assignmentId;
  const [responseData, setResponseData] = useState({});
  const [reviewList, setReviewList] = useState([]);
  const [isReviewLoaded, setIsReviewLoaded] = useState(false); // State to track API call status

  useEffect(() => {
    getReviewQuizDetails();
  }, [trainingIdProp,blendedIdProp,learningPlanIdProp,assignmentIdProp]);

  useEffect(() => {
    if (responseData && responseData.questions) {
      setReviewList(responseData.questions);
    }
  }, [responseData]);

  const getReviewQuizDetails = async () => {
    try {
      const payload = { 
        courseId: trainingId,
        blendedProgramId: blendedIdProp || "",
        learningplanId : learningPlanIdProp || "",
        assignmentId: assignmentIdProp || ""
       };
      const res = await postApiCall("getAssessmentQuizReviewById", payload);
      setResponseData(res);
      setIsReviewLoaded(true); // Set the state to true when API call is successful
    } catch (err) {
      var errMsg = err?.response?.data?.error;
    }
  };

  return (
    <div>
      <div style={{ width: "100%" }} className="questionAnswerHeight">
        {reviewList.map((item, index) => {
          const isCorrect = item.isCorrect === 1;
          const answerStyle = {
            backgroundColor: isCorrect ? '#d9eee1' : '#ffc0c7', // Green for correct, Pink for wrong
            color: 'black', // Black text color
            padding: '10px',
            borderRadius: '5px',
            marginBottom: '10px', // Add space between cards
          };

          switch (item.questionTypeId) {
            case 1:
              return (
                <div style={answerStyle} key={index}>
                  <MultipleChoice
                    type={"1"}
                    num={index}
                    question={item.question}
                    score={responseData?.quizType === "Quiz" ? item.questionScore : ''}
                    data={item.options}
                    questionID={item.questionId}
                    questionTypeID={item.questionTypeId}
                    assessmentID={item.assessmentSettingId}
                    isCorrect={item.isCorrect}
                    correctAnswer={item.correctAnswer} // Pass correct answer id
                    userAnswer={item.userAnswer}
                  />
                </div>
              );
            case 2:
              return (
                <div style={answerStyle} key={index}>
                  <MultipleSelect
                    type={"1"}
                    num={index}
                    question={item.question}
                    score={responseData?.quizType === "Quiz" ? item.questionScore : ''}
                    data={item.options}
                    questionTypeID={item.questionTypeId}
                    assessmentID={item.assessmentSettingId}
                    questionID={item.questionId}
                    isCorrect={item.isCorrect}
                    correctAnswer={item.correctAnswer} // Pass correct answer id
                    userAnswer={item.userAnswer}
                  />
                </div>
              );
            case 3:
              return (
                <div style={answerStyle} key={index}>
                  <TrueFalse
                    type={"1"}
                    num={index}
                    question={item.question}
                    score={responseData?.quizType === "Quiz" ? item.questionScore : ''}
                    data={item.options}
                    questionID={item.questionId}
                    assessmentID={item.assessmentSettingId}
                    questionTypeID={item.questionTypeId}
                    isCorrect={item.isCorrect}
                    correctAnswer={item.correctAnswer} // Pass correct answer id
                    userAnswer={item.userAnswer}
                  />
                </div>
              );
            case 4:
              return (
                <div style={answerStyle} key={index}>
                  <YesNo
                    type={"1"}
                    num={index}
                    question={item.question}
                    score={responseData?.quizType === "Quiz" ? item.questionScore : ''}
                    data={item.options}
                    questionID={item.questionId}
                    assessmentID={item.assessmentSettingId}
                    questionTypeID={item.questionTypeId}
                    isCorrect={item.isCorrect}
                    correctAnswer={item.correctAnswer} // Pass correct answer id
                    userAnswer={item.userAnswer}
                  />
                </div>
              );
            case 5: // Text Answer case
              return (
                <div style={answerStyle} key={index}>
                  <TextAnswer
                    type={"1"}
                    num={index}
                    question={item.question}
                    score={responseData?.quizType === "Quiz" ? item.questionScore : ''}
                    data={item.options}
                    questionID={item.questionId}
                    assessmentID={item.assessmentSettingId}
                    questionTypeID={item.questionTypeId}
                    isCorrect={item.isCorrect}
                    correctAnswer={item.noOptionAns} // Pass correct answer
                    userAnswer={item.userAnswer} // Pass user answer
                    isReviewLoaded={isReviewLoaded} // Pass the state
                  />
                </div>
              );
            case 6:
              return (
                <div style={answerStyle} key={index}>
                  <NumericResponse
                    type={"1"}
                    num={index}
                    question={item.question}
                    score={responseData?.quizType === "Quiz" ? item.questionScore : ''}
                    data={item.options}
                    questionID={item.questionId}
                    assessmentID={item.assessmentSettingId}
                    questionTypeID={item.questionTypeId}
                    isCorrect={item.isCorrect}
                    correctAnswer={item.noOptionAns} // Pass correct answer
                    userAnswer={item.userAnswer} // Pass user answer
                    isReviewLoaded={isReviewLoaded} // Pass the state
                  />
                </div>
              );
            case 7:
              return (
                <div style={answerStyle} key={index}>
                  <FillInTheBlanks
                    type={"1"}
                    num={index}
                    question={item.question}
                    score={responseData?.quizType === "Quiz" ? item.questionScore : ''}
                    data={item.options}
                    questionID={item.questionId}
                    assessmentID={item.assessmentSettingId}
                    questionTypeID={item.questionTypeId}
                    isCorrect={item.isCorrect}
                    correctAnswer={item.noOptionAns} // Pass correct answer
                    userAnswer={item.userAnswer} // Pass user answer
                    isReviewLoaded={isReviewLoaded} // Pass the state
                  />
                </div>
              );
            default:
              return <p key={index}>No Quiz</p>;
          }
        })}
      </div>
    </div>
  );
}

export default ReviewQuiz;
